import React, { useEffect, useState } from "react";
import { Badge, Container, Table } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import { useSelector } from "react-redux";
import { selectUser } from "../store/userSlice";

export default function Rules() {
  const user = useSelector(selectUser);
  const [rules, setRules] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("status")
    ? searchParams.getAll("status")
    : ["active", "inactive"];

  const statusesOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "archived", label: "Archived" },
  ];

  const getRules = async () => {
    let headersList = {
      Accept: "*/*",
    };

    let response = await fetch(
      `/auth/rules?${status.map((s) => `status=${s}`).join("&")}`,
      {
        method: "GET",
        headers: headersList,
      }
    );

    let data = await response.json();
    if (response.ok) {
      setRules(data.data);
    } else {
      toast.error(data.error);
      if (response.status === 401) {
        if (user) {
          toast.error("Your session has expired. You need to login again.");
        }
        navigate("/login", { state: { from: location } });
      }
    }
  };

  useEffect(() => {
    getRules();
  }, [location]);

  return (
    <Container fluid>
      <div className="row my-3">
        <div className="col-3">
          <h3 className="">Rules</h3>
        </div>
        <div className="col-12 col-md-3 offset-md-6 d-flex align-items-center">
          <span className="me-2">Status</span>
          <div className="flex-grow-1">
            <Select
              value={statusesOptions.filter((s) => status.includes(s.value))}
              onChange={(values) => {
                if (values.length === 0) {
                  return;
                }
                searchParams.delete("status");
                values.forEach((v) => searchParams.append("status", v.value));
                setSearchParams(searchParams);
              }}
              isMulti
              options={statusesOptions}
              maxMenuHeight={150}
            />
          </div>
        </div>
      </div>
      <Table bordered hover>
        <thead>
          <tr>
            <th></th>
            <th>Status </th>
            <th>Description </th>
            <th>Message </th>
            <th>Details </th>
            <th>Alert email</th>
          </tr>
        </thead>
        <tbody>
          {rules.map((r) => (
            <tr>
              <td>
                <span className="text-nowrap">
                  <Link
                    className="btn badge btn-secondary me-2"
                    to={`/rules/${r.Id}`}
                  >
                    Edit
                  </Link>
                  <Link
                    className="btn badge btn-secondary"
                    to={`/alerts?rules=${r.Id}${r.DbRef	?`&dbRef=${r.DbRef}`:''}`}
                  >
                    Alerts
                  </Link>
                </span>
              </td>
              <td>
                {r.Status === "active" ? (
                  <span className="badge bg-success">active</span>
                ) : null}
                {r.Status === "inactive" ? (
                  <span className="badge bg-primary">inactive</span>
                ) : null}
                {r.Status === "archived" ? (
                  <span className="badge bg-secondary">archieved</span>
                ) : null}
              </td>
              <td>{r.Description}</td>
              <td>{r.Message}</td>
              <td>
                <div dangerouslySetInnerHTML={{ __html: r.Summary }} />
              </td>
              <td>
                {r.Options.filter((o) => o.Key === "alert:email")
                  .map((o) => o.Value)
                  .join(", ")}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}
